import { render } from "./DeleteConfirmDialog.vue?vue&type=template&id=51c4fbfd&scoped=true"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=51c4fbfd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c4fbfd"]])

export default __exports__